import { Navigate } from 'react-router-dom';
import { useState } from 'react';
import WaiterHeader from '../header/WaiterHeader';
import methods from '../../services/utility';

const WaiterLayout = ({ component: Component, ...rest }) => {
    const isUserLogedin = methods.checkUserLogin();
    return (
        <div className='container-fluid'>
            {isUserLogedin ?
                <>
                    <WaiterHeader />
                    <div className='row'>
                        <div className={`col-lg-12 mt-3 mx-auto`}>
                            <Component {...rest} />
                        </div>
                    </div>
                </>
                :
                <Navigate to="/login" />
            }
        </div>
    )
};

export default WaiterLayout;